import { render, staticRenderFns } from "./mypage.vue?vue&type=template&id=42f2da0a&scoped=true&"
import script from "./mypage.vue?vue&type=script&lang=ts&"
export * from "./mypage.vue?vue&type=script&lang=ts&"
import style0 from "./mypage.vue?vue&type=style&index=0&id=42f2da0a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42f2da0a",
  null
  
)

export default component.exports